import { render, staticRenderFns } from "./ConferenceProductCard.vue?vue&type=template&id=752ceb49&scoped=true&"
import script from "./ConferenceProductCard.vue?vue&type=script&lang=js&"
export * from "./ConferenceProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceProductCard.vue?vue&type=style&index=0&id=752ceb49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752ceb49",
  null
  
)

export default component.exports